import React, { useEffect, useMemo, useCallback, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import api from "api";
import Swal from "sweetalert2";
import FormBuilderRender from "components/formbuilder/FormBuilderRender";
import { FormBuilderRenderContext } from "components/formbuilder/FormBuilderRenderContext";
export default function AdminFormalityRequestEditModal({
  show,
  request,
  onClose,
  onSaved,
  isReadOnly = false
}) {
  const [formData, setFormData] = useState(request.frData || {});
  const [analysis, setAnalysis] = useState(request.frAnalysis || {});
  const [saveSignal, setSaveSignal] = useState(0);
  const [isDirty, setisDirty] = useState(false);
  const [saving, setSaving] = useState(false);
  const [fbSaveButton, setFBSaveButton] = useState(null);
  const [statusInfo, setStatusInfo] = useState(null);
  const [validationErrors, setValidationErrors] = useState(null);
  const fbIsAdmin = true;
  const formMeta = useMemo(() => ({
    id: request.template.ftId,
    title: request.template.ftName,
    description: request.template.ftSummary || "",
    layout: request.template.ftLayout,
    pricing: request.template.ftTotalPriceET,
    isReadOnly,
    isCompleted: request.frStatus === "completed",
  }), [request, isReadOnly]);
  useEffect(() => {
    setisDirty(false);
    setFBSaveButton({
      label: "Enregistrer",
      onClick: handleSave,
      className: 'btn-warning',
      visible: true,
    })
    if (request.validation.validated == true) {
      setValidationErrors(null)
    }
    if (request.validation.validated == false) {
      setValidationErrors(request.validation.errors)
    }
  }, [request.frId])
  useEffect(() => {
    if (validationErrors === null) {
      setStatusInfo({ visible: true, className: 'success', content: "Tous les champs requis sont renseignés." })
    } else {
      setStatusInfo({ visible: true, className: 'danger', content: "Cette demande n'est pas conforme.<br />(champs requis manquant)" })
    }
  }, [validationErrors]);
  const handleChange = useCallback(async (data) => {

    setFormData(data)
    setisDirty(true);
  }, [request.frId, analysis, onSaved]);
  const handleSave = useCallback(async (data) => {
    setSaving(true);
    try {
      const res = await api.put(
        `/admin/formalities/request/${request.frId}`,
        {
          frData: data,
        }
      );
      setFormData(res.data.frData);
      setAnalysis(res.data.frAnalysis ?? analysis);
      setSaveSignal(Date.now());
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Demande mise à jour",
        showConfirmButton: false,
        timer: 1500,
      });
      setisDirty(false);
      onSaved?.(res.data);
      // setFormData()
      if (res.data) {
        if (res.data.validation.validated == true) {
          setValidationErrors(null)
        }
        if (res.data.validation.validated == false) {
          setValidationErrors(res.data.validation.errors)
        }
      }
    } catch (e) {
      console.error(e);
      Swal.fire("Erreur", "Impossible d’enregistrer la demande", "error");
    } finally {
      setSaving(false);
    }
  }, [request.frId, analysis, onSaved]);
  const handleRequestClose = useCallback(async () => {
    if (!isDirty) {
      onClose();
      return;
    }
    const result = await Swal.fire({
      title: "Modifications non enregistrées",
      text: "Des modificationss en cours. Confirmez vous la fermeture ?",
      showCancelButton: true,
      confirmButtonText: "Oui, fermer",
      cancelButtonText: "Annuler",
      confirmButtonColor: "#d33",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      onClose();
    }
  }, [isDirty, onClose]);
  const fbOpenDocument = useCallback(async (file, field) => {
    const res = await api.post(
      `/admin/formalities/request/${request.frId}/document/open`,
      {
        file,
        field,
      },
      { responseType: "blob" }
    );
    const url = URL.createObjectURL(res.data);
    window.open(url, "_blank", "noopener");
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  }, [request.frId]);
  /** DELETE DOCUMENT */
  const fbDeleteDocument = useCallback((file, field) => {
    const parents = field.parents || [];
    const fieldName = field.name;
    setFormData(prev => {
      const next = { ...prev };
      // Naviguer dans parents
      let target = next;
      for (const parent of parents) {
        if (!target[parent]) return prev;
        target[parent] = { ...target[parent] };
        target = target[parent];
      }
      // Supprimer le fichier dans le tableau
      if (Array.isArray(target[fieldName])) {
        target[fieldName] = target[fieldName].filter(
          f => f.path !== file.path
        );
      }
      return next;
    });
    setisDirty(true);
  }, []);
  const fbDeleteDocument0 = useCallback(async (file, field) => {

    const res = await api.post(
      `/admin/formalities/request/${request.frId}/document/delete`,
      {
        file,
        field,
      },
    );
    if (res.data) {
      setFormData(res.data.frData)
      if (res.data.validation.validated == true) {
        setValidationErrors(null)
      }
      if (res.data.validation.validated == false) {
        setValidationErrors(res.data.validation.errors)
      }
    }
  }, [request.frId]);
  const topButtons = useMemo(() => [
    {
      label: "Enregistrer",
      onClick: handleSave,
      className: "btn-warning",
      visible: true,
    }
  ], [handleSave]);
  return (
    <Modal show={true} onHide={handleRequestClose} size="xl" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          {request.frCustomName}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormBuilderRenderContext.Provider value={{ fbOpenDocument, fbDeleteDocument, fbIsAdmin }}>
          <FormBuilderRender
            externalSchema={request.template.format.schema}
            meta={formMeta}
            formDataInitial={formData}
            analysis={analysis}
            isReadOnly={false}
            validationErrors={validationErrors}
            onSave={handleSave}
            onChange={handleChange}
            saveSignal={saveSignal}
            topButtons={topButtons}
            statusInfo={statusInfo}
          />
        </FormBuilderRenderContext.Provider>
      </Modal.Body>
      <Modal.Footer className="d-none">
        <Button variant="secondary" onClick={handleRequestClose}>
          Fermer
        </Button>
        {!isReadOnly && (
          <Button
            variant="primary"
            onClick={() => handleSave(formData)}
            disabled={saving}
          >
            Enregistrer
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
